module.exports = __webpack_public_path__ + "assets/img/chronicleImgActive-0263898c.png";